import React from "react";

/**
 * Contract Holder Program Performance "Information Distribution" More Info Component
 * @returns {Element}
 * @constructor
 */
export default function InformationDistribution() {
  return (<tr className="extra-info">
    <td colSpan={6}>
      <div>
        <h6 className="bold">Information Distribution</h6>
        <p>The Information Distribution rating is based the accuracy of the information provided by Contract Holder to
          Customers through sales agents, associated companies, website, handouts and etc. <br /><br />
          The Contract Holder is responsible for communicating correct information on all business aspects that apply to
          the SEWP Program.</p>

        <ul className="performance-desc-range">
          <li className="excellent">Excellent - 0-1</li>
          <li className="very-good">Very Good - 2-3</li>
          <li className="good">Good - 4-5</li>
          <li className="fair">Fair - 6</li>
          <li className="poor">Poor - &#62; 7</li>
        </ul>

        <ul>
          <li><strong>Excellent</strong> = 0-1 instance of incorrect or partial information provided to customer</li>
          <li><strong>Very Good</strong> = 2-3 instances of incorrect or partial information and Contract Holder quickly
            resolved situation
          </li>
          <li><strong>Good</strong> = 4-5 instances of incorrect or partial information and contract holder quickly
            resolved situation or instances of incorrect or partial information were not resolved and/or were repeated
          </li>
          <li><strong>Fair</strong> = 6 instances of incorrect or partial information and contract holder quickly
            resolved situation or instances of incorrect or partial information were not resolved and/or were repeated
          </li>
          <li><strong>Poor</strong> = 7+ requests to fix incorrect or partial information continuously ignored</li>
          <li><strong>Neutral</strong> = Contract Holder has not received any orders or performed any work on the SEWP
            contracts to date
          </li>
        </ul>
      </div>
    </td>
  </tr>);
}